import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=6afbaa60&scoped=true&"
import script from "./InvoiceItem.vue?vue&type=script&lang=js&"
export * from "./InvoiceItem.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=6afbaa60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbaa60",
  null
  
)

export default component.exports